import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class SerialNumberColumn extends Column {
    title = 'table.assets.serialNumberColumn';
    property = 'serialNumber';
    sortable = false;
    type: CellDisplay = CellDisplay.string;
}
